import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowright",
  "use": "icon-arrowright-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-arrowright\"><path d=\"M170.686778 511.698504L682.385283 0l170.525968 170.646567-341.172535 341.051937 341.172535 341.051938-170.525968 170.646567z\" fill=\"currentColor\" p-id=\"1967\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol